import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { Box, Typography } from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "./FAQ.scss";

const FAQ = ({
  data,
}: {
  data: { expanded: string; title: string; description: any }[];
}) => {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Box className="pt-4 w-full">
      <Grid container columnSpacing={3} rowSpacing={0}>
        <Grid xs={12} className="faq">
          {data.map((data, index) => (
            <Accordion
              key={index}
              expanded={expanded === data.expanded}
              onChange={handleChange(data.expanded)}
            >
              <AccordionSummary
                expandIcon={
                  expanded === data.expanded ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )
                }
                aria-controls={data.expanded + "bh-content"}
                id={data.expanded + "bh-header"}
              >
                <img src="./images/shield-icon.svg" width="21px" />{" "}
                <Typography>{data.title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{data.description}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FAQ;
